// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.list-content-box[data-v-594d6191]{\n  word-break: break-all;\n  line-height: 24px;\n}\n.list-title-box[data-v-594d6191]{\n  font-size: 20px;\n  font-weight: 800;\n}\n", ""]);
// Exports
module.exports = exports;
